import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import FLCEstimatorApp from './FLCEstimator';

const PASS_HASH = "b3a16c3a5e6a8e9d1f2c4b5a7e8d9f0c1a2b3e4f5a6b7c8d9e0f1a2b3c4d5e6"; // placeholder

function hashPass(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  }
  return h.toString(36);
}

function PasswordGate({ children }) {
  const [authed, setAuthed] = useState(false);
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const stored = sessionStorage.getItem("flc_auth");
    if (stored === "blu2026") setAuthed(true);
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    if (pass === "BLUCrew2026!") {
      sessionStorage.setItem("flc_auth", "blu2026");
      setAuthed(true);
    } else {
      setError("Incorrect password");
      setTimeout(() => setError(""), 2000);
    }
  }

  if (authed) return children;

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #1B3A5C, #0D1F38)",
      fontFamily: "system-ui, -apple-system, sans-serif"
    }}>
      <form onSubmit={handleSubmit} style={{
        background: "white",
        borderRadius: 16,
        padding: "40px 36px",
        width: 340,
        boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
        textAlign: "center"
      }}>
        <div style={{ fontSize: 32, marginBottom: 8 }}>🔒</div>
        <h1 style={{ margin: "0 0 4px", fontSize: 20, fontWeight: 800, color: "#1B3A5C" }}>FLC Estimator</h1>
        <p style={{ margin: "0 0 24px", fontSize: 13, color: "#999" }}>Enter password to continue</p>
        <input
          type="password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          placeholder="Password"
          autoFocus
          style={{
            width: "100%",
            padding: "12px 16px",
            borderRadius: 10,
            border: "1.5px solid #DDD",
            fontSize: 15,
            outline: "none",
            boxSizing: "border-box",
            marginBottom: 12
          }}
        />
        <button type="submit" style={{
          width: "100%",
          padding: "12px",
          borderRadius: 10,
          border: "none",
          background: "#2E75B6",
          color: "white",
          fontSize: 15,
          fontWeight: 700,
          cursor: "pointer"
        }}>Enter</button>
        {error && <p style={{ color: "#E53935", fontSize: 13, marginTop: 12 }}>{error}</p>}
        <p style={{ margin: "20px 0 0", fontSize: 10, color: "#CCC" }}>BLU Crew — Powered by Fresh Local Cleaning</p>
      </form>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PasswordGate>
      <FLCEstimatorApp />
    </PasswordGate>
  </React.StrictMode>
);
